import { Room } from '../../interfaces/rooms';
import { rooms } from '../../api/rooms';

async function fetchRooms(): Promise<Room[]> {
	try {
		return await rooms.getRooms();
	} catch (error) {
		throw error;
	}
}

export const roomService = {
	fetchRooms,
};
